export const iconFontAwesomePhotosImagesEyeDropper = (
	<i className="fa-solid fa-eye-dropper"></i>
);
